import * as Config from './config.json'

export default Config
